import styled from 'styled-components';

const Container = styled.div`
    position: absolute;
    top: -40px;
    left: 50%;
    transform: translateX(-50%);
    z-index: ${props => props.zIndex ?? 2};
    @media screen and (max-width: 800px) {
        top: -4vh;
    }
`;

const SVG = styled.svg`
    width: 5vw;
    height:64px;
    @media screen and (max-width: 800px) {
        width: 50px;
    }
`;

const BlockCone = ({startColor = '#bcbcbc', stopColor = '#bababa'}) =>
    <Container>
        <SVG viewBox="0 0 95 64" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M93.2442 59.4236C92.3635 60.5719 91.0927 61.5253 89.5607 62.187C88.0286 62.8487 86.29 63.1951 84.5213 63.191H10.7127C8.94399 63.196 7.20501 62.8505 5.67236 62.1895C4.13972 61.5286 2.86799 60.5758 1.98633 59.4279C1.10466 58.2799 0.644456 56.9778 0.652446 55.6537C0.660436 54.3295 1.13634 53.0306 2.03182 51.8887L38.8942 4.16745C39.7767 3.01972 41.0476 2.06639 42.579 1.40351C44.1104 0.740626 45.8481 0.391602 47.617 0.391602C49.386 0.391602 51.1237 0.740626 52.655 1.40351C54.1864 2.06639 55.4574 3.01972 56.3399 4.16745L93.2022 51.8887C94.1045 53.0281 94.584 54.3272 94.5914 55.6518C94.5988 56.9765 94.1337 58.2785 93.2442 59.4236Z"
                fill="url(#paint0_linear_51_664)" style={{mixBlendMode: 'normal'}}/>
            <defs>
                <linearGradient id="paint0_linear_51_664" x1="0.652344" y1="31.7913" x2="94.5915" y2="31.7913"
                                gradientUnits="userSpaceOnUse">
                    <stop offset="0.253125" stopColor={startColor}/>
                    <stop offset="0.711458" stopColor={stopColor}/>
                </linearGradient>
            </defs>
        </SVG>
    </Container>
;
export default BlockCone;